// Cores predefinidas para os bloqueios (aparecem na Agenda do Dia e na página Bloqueios)
export const CORES_BLOQUEIO = ['#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6', '#EC4899', '#6B7280', '#8B4A2F']

// Motivos predefinidos por omissão (aparecem no seletor de motivo, com opção
// "Outro" para texto livre) — usados enquanto o tenant não configurar a sua
// própria lista em Configurações ("motivos_bloqueio", JSON de strings).
export const MOTIVOS_BLOQUEIO = ['Bloqueado', 'Folga', 'Férias', 'Almoço', 'Doença', 'Formação', 'Reunião']

// Lê a lista de motivos configurada pelo tenant a partir de getConfiguracoes();
// cai para MOTIVOS_BLOQUEIO se ainda não estiver definida, vazia ou inválida.
export function motivosBloqueioDeConfig(cfg) {
  try {
    const lista = JSON.parse(cfg?.motivos_bloqueio || 'null')
    if (Array.isArray(lista) && lista.length > 0) return lista
  } catch { /* usa MOTIVOS_BLOQUEIO */ }
  return MOTIVOS_BLOQUEIO
}

// Duração mínima de um bloqueio, em minutos — configurável em Configurações
// ("bloqueio_duracao_minima"); cai para este valor por omissão se não estiver
// definida ou for inválida.
export const DURACAO_MINIMA_BLOQUEIO = 5

export function duracaoMinimaBloqueioDeConfig(cfg) {
  const n = parseInt(cfg?.bloqueio_duracao_minima, 10)
  return n > 0 ? n : DURACAO_MINIMA_BLOQUEIO
}
